import { Component, Input,  OnChanges,  OnDestroy, OnInit, SimpleChanges, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { ALLOWED_ITEM_FROM_WIDGET_LIST, DROPDOWN_DATASOURCE_FILTERTYPES, PAGETYPES, VALIDATIONS, WIDGET_ACTIONS, WIDGET_ACTIONS_VALIDATIONS, WIDGET_CLICK_ACTIONS, WIDGET_CLICK_ACTIONS_LABEL, WIDGET_TYPES } from '../../../../constants/proj.cnst';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {  debounceTime, firstValueFrom,  Subject, takeUntil } from 'rxjs';
import { SharedService } from '../../../Services/shared.service';
import { ActivatedRoute, Params } from '@angular/router';
import { APIConfigMapping, ApiconfigService, APP_BUILDER_PERMISSIONS, HTTPAPIConfig, isNullOrUndefined, matInputErrorStateMatcher, PERMISSIONS_ACTIONS, USERDEFINEDAPI, USERDEFINEDAPIVARIABLE, VlDataService, VlHttpService } from 'shared-library';
import { WidgetPropertyFormService } from '../../widget-property-form.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {ACTIONCONDITIONALCLAUSE, WIDGETACTION} from './models/widget-actions.model'
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PageRearrangeService } from '../../../mobi-pages/services/page-rearrange.service';

@Component({
  selector: 'lib-widget-actions',
  templateUrl: './widget-actions.component.html',
  styleUrl: './widget-actions.component.scss'
})
export class WidgetActionsComponent implements OnInit,OnChanges ,OnDestroy {
  @Input() widget: any;
  @Input() currentPageWidgets: any;
  @Input() applicationId:string = '';
  @Output() widgetRef: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;

  matInputError: ErrorStateMatcher = new matInputErrorStateMatcher();
  
  selectedActions: string[] = [];
  buttonActions: {label:string,action:string}[] = WIDGET_ACTIONS;
  widgetClickActions = WIDGET_CLICK_ACTIONS;
  widgetValidationTypes:typeof VALIDATIONS = VALIDATIONS;
  pageTypes = PAGETYPES;
  widgetActionsandValidations = WIDGET_ACTIONS_VALIDATIONS;
  actionsLabel:any = WIDGET_CLICK_ACTIONS_LABEL;
  queryParams!: any;
  pages:any = [];
  validPages:any = [];
  entities:any = [];
  selectedEntityWorkflows:any = [];
  NavigationConditionals:any = [];

  // Form groups
  actionForm!: FormGroup;
  navigationGroup!: FormGroup;                      // Navigation aciton group
  lineItemGroup!: FormGroup;                        // line item action
  workFlowGroup!:FormGroup;                         // workflow action
  previewGroup!:FormGroup;                          // submit action
  conditionalActionGroup!:FormGroup;                // conditional navigation action
  conditionalActionUpdatedGroup!:FormGroup;         // conditional navigation action update form
  workFlowConditionGroup!:FormGroup;                // conditional workflow action;
  workFlowConditionUpdatedGroup!:FormGroup;         // conditional workflow action update form;
  conditionalWorkFlowEditGroup!:FormGroup;          // conditional workflow action edit Group
  requestGroup!:FormGroup                           // Request action

  // subjects
  destroy$:Subject<void> = new Subject<void>();

  // conditional Navigation
  conditionalActions:any = [];
  currentConditions:any = [];
  currentPageConditionalWidgetsUpdate:any = [];
  entitybasedPageWidgetsGroup = [];
  currentEntitybasedConditionalWidgets:any = [];

  //line item action
  listOfWidgetsOfEntity:any = [];
  filterWidgetList:any = [];
  isRhsclicked: boolean = false;
  isLhsclicked: boolean = false;
  entityButtonWidgets:any = [];
  widgetsforDefaultValues:any = [];
  widgetsforValidations:any = [];
  entityWidgets:any = [];
  validationEntityGroup!:FormGroup;
  filterValues:any = [];

  // workflow conditional action
  workflowConditionalActions:any = [];
  workflowConditions:any = [];
  currentPageworkflowConditionalWidgetsUpdate:any = [];
  resetSearchVar:boolean = true;
  
  // template #actionConditions
  conditionalKeyValue: any = [];
  widgetTypes = WIDGET_TYPES;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  currentPageConditionalWidgets : any = [];
  dropdownValues:any = [];
  fieldCtrl = new FormControl('');

  //Request action
  variableGroup!:FormGroup;
  userconfiguredApis:any = [];
  apiKeyPaths:any = [];

  // healper
  entitiesWidgetsMaping:any = {};
  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;

  constructor(private _formBuilder:FormBuilder,private sharedService:SharedService,private route:ActivatedRoute,private dataService: VlDataService,private httpService: VlHttpService,private widgetPropertyFormService: WidgetPropertyFormService, private apiConfigService:ApiconfigService, private dialog: MatDialog,private toastrSrv:ToastrService,private pageRearrangeService:PageRearrangeService){
  }

  ngOnInit(): void {
    this.formsInitializer();
    this.componentSetter();
    this.routeParamsSubscription();
    this.getAllPages();
    this.fetchEntitys();
    this.patchActions(this.widget);
    this.formValueChangesSubscription();
  }

  ngOnChanges(changes: SimpleChanges): void {
      if(changes['widget']?.currentValue.widgetId !== changes['widget']?.previousValue?.widgetId && !changes['widget']?.firstChange){
        this.componentSetter();
        this.patchActions(this.widget);
      }
  }

  componentSetter(){
    this.selectedActions = [];
    this.conditionalActions = [];
    this.workflowConditions = [];
    this.workflowConditionalActions = [];
    this.actionForm.reset();
    this.buttonActions = this.getFilteredActions(this.widgetActionsandValidations[this.widget.widgetType].action);
  }

  formsInitializer(){
    this.actionForm = this._formBuilder.group({
      selectedAction: ['']
    });

    this.navigationGroup = this._formBuilder.group({
      pageName: ['', Validators.required]
    });

    this.validationEntityGroup = this._formBuilder.group({
      foreignEntityId:[''],
      label:[''],
      key:[''],
      filters:this._formBuilder.array([]),
      basedOn:[''],
      operator:['']
    })

    this.lineItemGroup = this._formBuilder.group({
      pageName: ['', Validators.required],
      entityId: ['', Validators.required],
      lhsItems: this._formBuilder.array([]),
      rhsItems: this._formBuilder.array([]),
      bulk:[false],
      table:[false],
      delete: [false],
      referenceWidget:[''],
      displayLineItems:[false,],
      defaultValues: this._formBuilder.array([]),
      validations: this._formBuilder.array([]),
      validationErrorMessage:[''],
      validationType:[''],
      validationEntity:this.validationEntityGroup,
    });

    this.previewGroup = this._formBuilder.group({
      preview: [, Validators.required],
    });

    this.workFlowGroup = this._formBuilder.group({
      entity: ['', Validators.required],
      workFlowName: ['', Validators.required]
    });

    this.conditionalActionGroup = this._formBuilder.group({
      pageName: ['', Validators.required],
      parameters:[[]]
    });

    this.conditionalActionUpdatedGroup = this._formBuilder.group({
      pageName: ['', Validators.required],
      parameters:[[]]
    });

    this.workFlowConditionGroup = this._formBuilder.group({
      entity: ['', Validators.required],
      workFlowId: ['', Validators.required],
      parameters:[[]]
    });
    
    this.workFlowConditionUpdatedGroup = this._formBuilder.group({
      entity: ['', Validators.required],
      workFlowId: ['', Validators.required],
      parameters:[[]]
    });
    this.conditionalWorkFlowEditGroup = this._formBuilder.group({
      edit: [''],
      search: [''],
    });

    this.requestGroup = this._formBuilder.group({
      api:['',Validators.required],
      variables: this._formBuilder.array([]),
      displayKeys:[,Validators.required]
    });

    this.variableGroup = this._formBuilder.group({
      variableName:['',Validators.required],
      widget:['',Validators.required]
    });
  }

  getAllPages() {
    this.pages = this.sharedService.getPages();
    const order = this.sharedService.getApplicationDataEntire()['page_ids_list']
      if(order){
        this.pages = this.pageRearrangeService.rearrangePages(this.pages,order);
      }
  }

  routeParamsSubscription() {
    this.route.queryParams.pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams[param] = params[param];
        }
      }
    });
  }

  patchActions(widget:any){
      let widgetActions = widget.widgetConfig?.actions;
      widgetActions.forEach(async (action: WIDGETACTION) => {
        // Navgation action
        if (action.action_type === this.widgetClickActions.navigation) {
          const pageId = action.conditional_clause[0].action ?? '';
          const page = this.pages.find((page: any) => page.pageId === pageId);
          this.navigationGroup.get('pageName')?.patchValue(page.pageName ?? '');
          this.addAction(this.widgetClickActions.navigation);
        }
        // workflow action
        if (action.action_type === this.widgetClickActions.workFlow) {
          const entity = action.conditional_clause[0].entity ?? '';
          const workflowId = action.conditional_clause[0].action ?? '';
          this.selectedEntityWorkflows = await this.sharedService.fetchWorkFlows(entity, 'entity');
          const workflow = this.selectedEntityWorkflows.find((workflow : any) => workflow.workflow_id === workflowId)?.workflow_name
          this.workFlowGroup.patchValue({
            entity: entity,
            workFlowName: workflow
          })
          this.addAction(this.widgetClickActions.workFlow);
        }
        // line item action
        if (action.action_type === this.widgetClickActions.lineItem) {
          const pageId = action.conditional_clause[0].action ?? ''
          const page = this.pages.find((page: any) => page.pageId === pageId);
          this.lineItemGroup.get('pageName')?.patchValue(page.pageName ?? '');
          if( "lineItemConfig" in widget.widgetConfig.additionalConfig){
            let lineItemConfig = widget.widgetConfig.additionalConfig["lineItemConfig"];
            this.fetchEntitys();
            const payload = {
              application_id: this.queryParams["id"],
              entity_id: null,
              project_id: null,
              parent_entity_id: null
            }
              payload.entity_id = lineItemConfig.entityId
              const listOfPageWidgetsOfEntity = await this.widgetPropertyFormService.getEntitiesOrAttributes(payload).toPromise();
              this.listOfWidgetsOfEntity = this.retriveWidgetsListFromEntiy(listOfPageWidgetsOfEntity?.page_widget_details);
              this.entityWidgets = this.widgetPropertyFormService.retriveWidgetsListFromEntiywithConfig(listOfPageWidgetsOfEntity?.page_widget_details)
              this.filterButtonWidgets(this.entityWidgets);
              
              this.lhsItems.clear()
              lineItemConfig.lhsItems?.forEach((item: any) => {
                this.lhsItems.push(this.patchField(item.widgetId));
              })
              this.rhsItems.clear();
              lineItemConfig.rhsItems?.forEach((item: any) => {
                this.rhsItems.push(this.patchField(item.widgetId));
              })

              if(lineItemConfig.defaultValues){
                let customWidgetsObject = this.entityWidgets.reduce((result:any, widget:any) => {
                  const widgetId = widget.widgetId;
                  result[widgetId] = {
                    widget:widget,
                    options:widget.widgetDataSource?.datasource ?? []
                  };
                  return result;
                }, {} as Record<string, any>);
                this.lineItemdefaultValues.clear();
                let listofDefaultValues = Object.entries(lineItemConfig.defaultValues);
                listofDefaultValues.forEach((widgetItem:any) => {
                  this.lineItemdefaultValues.push(this.patchDefaultField(customWidgetsObject[widgetItem[0]],widgetItem[1]))
                })
              }
              if(this.widget.widgetConfig?.validations){
                const formValidation = this.widget.widgetConfig?.validations.find((validation:any) => validation.validation_type === this.widgetValidationTypes.formValidation)
                let customWidgetsObject = this.entityWidgets.reduce((result:any, widget:any) => {
                  const widgetId = widget.widgetId;
                  result[widgetId] = {
                    widget:widget,
                    options:widget.widgetDataSource?.datasource ?? []
                  };
                  return result;
                }, {} as Record<string, any>);
                if(formValidation){
                  this.lineItemGroup.get('validationType')?.patchValue(formValidation.validation_subtype ?? "manual");
                  this.lineItemValidations.clear();
                  if(formValidation?.validation_subtype === 'manual'){
                    let listofValidations = Array.isArray(formValidation.validation_value) ? formValidation.validation_value : [];
                    listofValidations.forEach((widgetItem:any) => {
                      if(customWidgetsObject[widgetItem.widgetId]){
                        this.lineItemValidations.push(this.patchValidationField(customWidgetsObject[widgetItem.widgetId],widgetItem,formValidation.validation_subtype))
                      }
                    })
                  }else if(formValidation?.validation_subtype === 'entity'){
                   this.filterValues = this.widgetPropertyFormService.formatInToFiltersArray(formValidation.filters ?? []);
                    this.validationEntityGroup.patchValue({
                      foreignEntityId:formValidation.validation_entity ?? '',
                      operator:formValidation.operator ?? '',
                      basedOn:formValidation.basedOn ?? [],
                      label:formValidation?.validation_value?.label ?? '',
                      key:formValidation?.validation_value?.key ?? '',
                    })
                  }
              
                  this.lineItemGroup.get('validationErrorMessage')?.patchValue(formValidation.error_message ?? "");
                }
              }
              

              this.filterWidgetList = this.updateFilterWidget(this.listOfWidgetsOfEntity);
              const patchValues = {
                entityId: lineItemConfig.entityId,
                lhsItems: lineItemConfig.lhsItems,
                rhsItems: lineItemConfig.rhsItems,
                bulk: lineItemConfig.bulk ?? false,
                table: lineItemConfig.table ?? false,
                delete: lineItemConfig.delete ?? false,
                referenceWidget: lineItemConfig.referenceWidget ?? "",
                displayLineItems: lineItemConfig.displayLineItems ?? false,
              };
              this.lineItemGroup.patchValue(patchValues);
          }
          this.addAction(this.widgetClickActions.lineItem);
        }
        // conditional navigation action
        if (action.action_type === this.widgetClickActions.conditionalNavigation) {
          this.conditionalActions = action.conditional_clause ?? [];
          this.addAction(this.widgetClickActions.conditionalNavigation);
        }
        // conditional workflow
        if (action.action_type === this.widgetClickActions.conditionalWorkflow) {
          this.workflowConditionalActions = action.conditional_clause ?? [];
          this.setConditionWorkflowsList(this.workflowConditionalActions);
          this.addAction(this.widgetClickActions.conditionalWorkflow);
        }
        // submit Action
        if (action.action_type === this.widgetClickActions.submit) {
          this.previewGroup.patchValue({
            preview: this.widget.widgetDataSource?.preview,
          })
          this.addAction(this.widgetClickActions.submit);
        }
        //request Action
        if(action.action_type === this.widgetClickActions.request){
          this.getUserApisList();
          this.requestGroup.get('api')?.patchValue(this.widget.widgetDataSource.datasource || '');
          this.makeApiCall(this.widget.widgetDataSource.datasource )
          this.requestGroup.get('displayKeys')?.patchValue(this.requestActionDisplayKeysObjectFormatter("patch",this.widget.widgetDataSource.displayKeys) ?? []);
          this.apiVariables.clear();
          let variables = this.widget.widgetDataSource.variableMappedWidgets;
          let selectedApi : USERDEFINEDAPI =  this.userconfiguredApis.apis.find((api:any) => api.apiId === this.widget.widgetDataSource.datasource);
          if (selectedApi.variables) {
            selectedApi.variables.forEach((variable:USERDEFINEDAPIVARIABLE) => {
              if(variables.hasOwnProperty(variable.key)){
                this.patchVariable({"variableName":variable.key,"widget":variables[variable.key]});
              }else{
                this.addVariable(variable);
              }
            })
          }
          this.addAction(this.widgetClickActions.request);
        }
      });
  }

  /**
   * Method to get Widget specific actions 
   * @param widgetSpecificActions : Actions allowed for current selected widget
   * @returns {label: string;action: string;}[]
   */
  getFilteredActions(widgetSpecificActions: string[]) : {label: string;action: string;}[] {
    return WIDGET_ACTIONS.filter(item => widgetSpecificActions.includes(item.action));
  };

  formValueChangesSubscription() {
    this.workFlowGroup.get("entity")
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(async (entityId: string) => {
        if (entityId) {
          await this.fetchWorkflows(entityId);
        }
      });

    this.workFlowConditionGroup.get('entity')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(async (entity: string) => {
      if(entity) {
        this.selectedEntityWorkflows = await this.sharedService.fetchWorkFlows(entity, 'entity');
        this.workFlowConditionGroup.get('workFlowId')?.reset();
      }
    });

    this.workFlowConditionUpdatedGroup.get('entity')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(async (entity: string) => {
      if(entity) {
        this.selectedEntityWorkflows = await this.sharedService.fetchWorkFlows(entity, 'entity');
        this.workFlowConditionUpdatedGroup.get('workFlowId')?.reset();
      }
    });

    this.conditionalWorkFlowEditGroup.get('edit')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(async (toggled: string) => {
      if(toggled) {
        this.workFlowConditionUpdatedGroup.reset();
        this.conditionalWorkFlowEditGroup.get('serch')?.reset();
      }else{
        this.workFlowConditionGroup.reset();
      }
    });

    this.requestGroupValueChanges();

    this.lineItemGroup.get('validationType')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((type:string) => {
      this.lineItemValidations.clear();
    })
  }

  async fetchEntitys() {
    this.entities = await this.sharedService.fetchEntity(this.queryParams["id"],"application");
    const entityIds = this.entities.map((entity:any) => entity.entity_id);
    this.setEntityWidgetsMapping(entityIds);
  }

  async fetchWorkflows(entityId: string) {
    this.selectedEntityWorkflows = await this.sharedService.fetchWorkFlows(entityId,"entity");
  }

  //#region Actions Managment
  /**
   * adds user selected action 
   * @param action : user selected action
   */
  async addAction(action: string) {
    this.actionForm.reset();
    if (action == this.widgetClickActions.conditionalNavigation) {
      this.conditionalActionGroup.reset(); 
      await this.setEntityWidgetsGroup(); 
      this.filterConditionalNavigationWidgets();
      this.NavigationConditionals = [];
    }else if(action == this.widgetClickActions.conditionalWorkflow || action === this.widgetClickActions.workFlow) {
      this.workFlowConditionGroup.reset();
      this.filterConditionalWidgets();
    } else if(action === this.widgetClickActions.request){
      this.getUserApisList();
    } else if(action === this.widgetClickActions.lineItem){
      this.lineItemValueChanges();

    }
    this.filterPages();
    this.buttonActions = this.buttonActions.filter((actionObj: any) => actionObj.action !== action)
    this.selectedActions.push(action);
  }

    /**
     * Deletes an action after user confirmation if valid, otherwise deletes it directly.
     * @param index - Index of the action to be deleted.
     * @param actionType - Type of the action to be deleted.
     * @param actions - Current widget actions.
     */
    async deleteAction(index: number, actionType: string, actions: WIDGETACTION[]) {
     

      if (!this.isValidAction(actionType)) {
        actions.splice(index, 1);
        this.updateActions(actions, actionType);
        this.resetAction(actionType);
        this.selectedActions.splice(index, 1);
        this.actionForm.reset();
        this.updateAvailableActionsList(actionType);
        return;
      }

      const dialogRef = this.dialog.open(this.confirmationDialog, {
        width: '400px',
        data: { message: 'Are you sure you want to delete this action?' }
        });

      dialogRef.afterClosed().subscribe(async (confirmed) => {
        if (confirmed) {
          if (actionType === this.widgetClickActions.submit) {
            this.widget.widgetDataSource = {};
            if (this.widget.widgetConfig["previewPageId"]) {
              const result = await this.widgetPropertyFormService.deletePreviewScreen(this.widget, this.queryParams['id'],this.pages);
              delete this.widget.widgetConfig["previewPageId"];
              if (!result?.status) return;
            }
          }
          actions.splice(index, 1);
          this.updateActions(actions, actionType);
          this.resetAction(actionType);
          this.selectedActions.splice(index, 1);
          this.actionForm.reset();
          this.updateAvailableActionsList(actionType);
        }
      });
    }

    /**
     * Validates whether an action can be safely deleted based on its type and associated form validity.
     * @param actionType - The type of action to validate.
     * @returns {boolean} - True if the action can be deleted, otherwise false.
     */
    isValidAction(actionType: string): boolean {
      switch (actionType) {
      case this.widgetClickActions.submit:
        return this.previewGroup.valid || this.widget.widgetConfig["previewPageId"];
      case this.widgetClickActions.request:
        return this.requestGroup.valid;
      case this.widgetClickActions.conditionalNavigation:
        return this.conditionalActionGroup.valid || this.conditionalActions.length > 0;
      case this.widgetClickActions.conditionalWorkflow:
        return this.workFlowConditionGroup.valid || this.workflowConditionalActions.length > 0;
      case this.widgetClickActions.navigation:
        return this.navigationGroup.valid;
      case this.widgetClickActions.lineItem:
        return this.lineItemGroup.valid;
      case this.widgetClickActions.workFlow:
        return this.workFlowGroup.valid;
      default:
        return true;
      }
    }

    /**
     * method is used to check if an action exists in current widget actions
     * @param actions :  current widget actions
     * @param actionType : current action type
     * @param conditionalClause :updated condtional clauses of the current action
     * @param dataSource : updated datasource of the current widget , if need to update along with action
     */
    checkActionExixtance(actions: WIDGETACTION[], actionType: string, conditionalClause:ACTIONCONDITIONALCLAUSE[],dataSource?:any) {
      const existingActionIndex = actions.findIndex((action: any) => action.action_type === actionType);
      const newAction = {
        action_type: actionType,
        conditional_clause: conditionalClause
      };
      // If  action exists, updating it; otherwise, adding a new one
      if (existingActionIndex !== -1) {
        actions[existingActionIndex] = newAction;
      } else {
        actions.push(newAction);
      }
      this.updateActions([...actions], actionType,dataSource);
    }
    
    /**
     * updates the widget actions by making an api call
     * @param actions  : updated list of actions
     * @param actionType : action type
     * @param dataSource : updated datasource of the current widget , if need to update along with action
     */
    updateActions(actions: WIDGETACTION[], actionType: string, dataSource?: any) {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
      this.widget.widgetConfig['actions'] = actions;
      this.widgetRef.emit(this.widget);
      apiConfig.postData = {
        'applicationId': this.queryParams['id'],
        'widgetConfig': this.widget.widgetConfig,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widget.widgetId
      }
      if ([this.widgetClickActions.submit,this.widgetClickActions.request].includes(actionType)) {
        apiConfig.postData['widgetDataSource'] = dataSource;
      }
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
        next: (data: any) => {
        },
        error: (err: any) => {
          if(err?.status == 403){
            this.toastrSrv.error('You do not have permission to access this resource.');
          }
        },
      });
    }

    /**
     * Resets the selected action's state
     * @param actionType : action type
     */
    resetAction(actionType:string){
      switch(actionType){
        case this.widgetClickActions.conditionalWorkflow:
          this.workFlowConditionGroup.reset();
          this.workFlowConditionUpdatedGroup.reset();
          this.workflowConditionalActions = [];
          this.workflowConditions = [];
          break;
        case this.widgetClickActions.navigation:
          this.navigationGroup.reset();
          break;
        case this.widgetClickActions.conditionalNavigation:
          this.conditionalActionGroup.reset();
          this.conditionalActionUpdatedGroup.reset();
          this.conditionalActions = [];
          this.currentConditions = [];
          break;
        case this.widgetClickActions.submit:
          this.previewGroup.reset();
          break;
        case this.widgetClickActions.lineItem:
          this.lineItemGroup.reset();
          break;
        case this.widgetClickActions.workFlow:
          this.workFlowGroup.reset();
          break;
        case this.widgetClickActions.request:
          this.requestGroup.reset();
          this.apiVariables.clear();
          break;
        default:
          break;
      }
    }

    /**
     * updates the list of available actions for the user to select
     * @param actionType : action to be added in select action dropdown
     */
    updateAvailableActionsList(actionType:string){
      let actionObj = WIDGET_ACTIONS.find((actionObj: {label: string;action: string;}) => actionObj.action === actionType);
      if(actionObj){
        this.buttonActions.push(actionObj);
      }
    }

  //#endregion

  //#region Navigation Action
    /**
     * filters pages to set valid pages for the user to select from
     */
    filterPages(){
      this.validPages = this.pages.filter((page:any) => [this.pageTypes.landingPage,this.pageTypes.customPage].includes(page.pageType) && page.pageId !== this.queryParams['pageId'])
    }

    addDefaultNavigationAction(){
      this.addNavigationOrLineItemAction(this.widget.widgetConfig.actions, this.navigationGroup, this.widgetClickActions.navigation);
    }
  //#endregion

  //#region Line item Action
      addLineItemAction(actions:WIDGETACTION[]){
        this.addNavigationOrLineItemAction(actions, this.lineItemGroup, this.widgetClickActions.lineItem);
      }

      get lhsItems() {
        return this.lineItemGroup.get('lhsItems') as FormArray;
      }
    
      get rhsItems() {
        return this.lineItemGroup.get('rhsItems') as FormArray;
      }

      get lineItemdefaultValues() {
        return this.lineItemGroup.get('defaultValues') as FormArray;
      }
      get lineItemValidations() {
        return this.lineItemGroup.get('validations') as FormArray;
      }

      lineItemValueChanges(){
        this.lineItemGroup.valueChanges.pipe(debounceTime(250)).subscribe((value:any) => {
          const pageId = this.pages.find((page: any) => page.pageName === value?.pageName)?.pageId;
          this.widgetPropertyFormService.setButtonLineItemConfig(this.widget.widgetId,value,pageId ?? '',this.listOfWidgetsOfEntity)
        })
      }



      
      validationsSetter(){
        let widgets = this.entityWidgets;
        this.widgetsforValidations = [];
        widgets.forEach((widget:any) => {
          let item = {
            widget:widget,
            options: widget.widgetDataSource?.datasource ?? []
          }
          this.widgetsforValidations.push(item);
        })

        if(this.lineItemdefaultValues?.length > 0){
          this.lineItemdefaultValues.value.forEach((widgetDefaultValue:any) => {
            const index = this.widgetsforValidations.findIndex((defaultValueWidget:any) => defaultValueWidget.widget.widgetId === widgetDefaultValue.widget.widget.widgetId);
            if(index !== -1){
              this.widgetsforValidations.splice(index,1);
            }
          })
        }

      }
      defaultValuesSetter(){
        let widgets = this.entityWidgets.filter((widget:any) =>  [this.widgetTypes.dropdown,this.widgetTypes.radio].includes(widget.widgetType));
        this.widgetsforDefaultValues = [];
        widgets.forEach((widget:any) => {
          let item = {
            widget:widget,
            options: widget.widgetDataSource?.datasource ?? []
          }
          this.widgetsforDefaultValues.push(item);
        })

        if(this.lineItemdefaultValues?.length > 0){
          this.lineItemdefaultValues.value.forEach((widgetDefaultValue:any) => {
            const index = this.widgetsforDefaultValues.findIndex((defaultValueWidget:any) => defaultValueWidget.widget.widgetId === widgetDefaultValue.widget.widget.widgetId);
            if(index !== -1){
              this.widgetsforDefaultValues.splice(index,1);
            }
          })
        }
      }
      
      addDefaultField(selecteWidgetOption:any): FormGroup {
        return this._formBuilder.group({
          widget: [selecteWidgetOption,Validators.required],
          value:''
        });
      }
      addValidationField(selecteWidgetOption:any,validationType:string): FormGroup {
        let validationFormGroup = validationType === 'manual' ? this._formBuilder.group({
          widget: [selecteWidgetOption,Validators.required],
          value:'',
          count:['',],
        }) : this._formBuilder.group({
          widget: [selecteWidgetOption,Validators.required],
          entityId:['',],
          count:['',],
          key:['',],
          value:['',],
        });
        return validationFormGroup;
      }

      patchDefaultField(widget_OptionsObj: any,value:any): FormGroup {
        return this._formBuilder.group({
          widget: widget_OptionsObj,
          value:value
        });
      }
      patchValidationField(widget_OptionsObj: any,validationOption:any,validationType:string): FormGroup {
        let validationFormGroup = validationType === 'manual' ? this._formBuilder.group({
          widget: [widget_OptionsObj ?? '',Validators.required],
          value:validationOption.value ?? '',
          count:[validationOption.count ?? '',],
        }) : this._formBuilder.group({
          widget: [widget_OptionsObj ?? '',Validators.required],
          entityId:[validationOption.value.entityId ?? '',],
          count:[validationOption.count ?? '',],
          key:[validationOption.value.key ?? '',],
          value:[validationOption.value.value ?? '',],
        });
        return validationFormGroup;
      }

      addDefaultFields(selecteWidgetOption:any,index:number) {
        this.lineItemdefaultValues.push(this.addDefaultField(selecteWidgetOption));
        this.widgetsforDefaultValues.splice(index,1);
      }

      addValidationFields(selecteWidgetOption:any,validationType:string){
        this.lineItemValidations.push(this.addValidationField(selecteWidgetOption,validationType));
        // this.widgetsforValidations.splice(index,1);
      }
    
      removeDefaultField(index: number,item:any) {
        this.lineItemdefaultValues.removeAt(index);
        this.widgetsforDefaultValues.push(item);
      }
      removeValidationField(index: number,item:any) {
        this.lineItemValidations.removeAt(index);
        this.widgetsforValidations.push(item);
      }

      defaultValuesFormatter(defaultValues:any){
        let values:any;
          values = defaultValues.reduce((result:any, item:any) => {
            const widgetId = item.widget.widget.widgetId;
            const value = item.value;
            result[widgetId] = value;
            return result;
          }, {} as Record<string, string | null>);
        return values;
      }

      validationsFormatter(validations:any,validationType:string){
        let values:any;
          values = validations.reduce((result:any, item:any) => {
            const widgetId = item.widget.widget.widgetId;
            result.push( validationType === 'manual' ? {value:item.value ?? '',count:item.count ?? '',widgetId:widgetId ?? ''} : {widgetId:widgetId ?? '',value:{value:item.value ?? '',key:item.key ?? '',entityId:item.entityId ?? ''},count:item.count ?? ''});
            return result;
          }, [] as any);
        return values;
      }

      filterButtonWidgets(entityWidgets:any){
        this.entityButtonWidgets = entityWidgets.filter((widget:any) => widget.widgetType === this.widgetTypes.button && this.findLineItemActions(widget.widgetConfig?.actions ?? []));
      }

      findLineItemActions(actions: any[]): boolean {
        return actions.some(action => action.action_type === 'lineItem');
      }

      getFilteredOptions(index: number, type: any): any[] {
        if(type != 'all'){
          const selectedOptions = type === 'lhs'
            ? this.lhsItems.controls.filter((control, i) => i !== index).map((control: any) => control.get('widgetId').value)
            : this.rhsItems.controls.filter((control, i) => i !== index).map((control: any) => control.get('widgetId').value);
          const otherSideOptions = type === 'lhs'
            ? this.rhsItems.controls.map((control: any) => control.get('widgetId').value)
            : this.lhsItems.controls.map((control: any) => control.get('widgetId').value);
          this.filterWidgetList =this.listOfWidgetsOfEntity.filter((widget: any) => {
            return ALLOWED_ITEM_FROM_WIDGET_LIST.includes(widget.widgetType);
          });
          return this.filterWidgetList.filter((option: any) =>
            !selectedOptions.includes(option.widgetId) && !otherSideOptions.includes(option.widgetId)
          );
        }else{
          
          return this.listOfWidgetsOfEntity.filter((widget: any) => {
            return ALLOWED_ITEM_FROM_WIDGET_LIST.includes(widget.widgetType);})
        }
      }

      async onEntitySelected(event:any,update?:boolean) {
        this.lhsItems.clear();
        this.rhsItems.clear();
        const payload = {
          application_id: this.queryParams['id'],
          entity_id: event.value ,
          project_id: null,
          parent_entity_id: null
        }
        const listOfPageWidgetsOfEntity = await this.widgetPropertyFormService.getEntitiesOrAttributes(payload).toPromise();
        this.listOfWidgetsOfEntity = this.retriveWidgetsListFromEntiy(listOfPageWidgetsOfEntity?.page_widget_details)
        this.filterWidgetList = this.updateFilterWidget(this.listOfWidgetsOfEntity);
        this.entityWidgets=this.widgetPropertyFormService.retriveWidgetsListFromEntiywithConfig(listOfPageWidgetsOfEntity?.page_widget_details)
        this.filterButtonWidgets(this.entityWidgets);
        if(update){
          this.validationsSetter();
        }
      }


      updateFilterWidget(data:any){
        const filterArray = data.filter((widget: any) => {
          return ALLOWED_ITEM_FROM_WIDGET_LIST.includes(widget.widgetType);
        }) ;
        return !isNullOrUndefined(filterArray) ? filterArray : [];
      }

      retriveWidgetsListFromEntiy(pageWidgetDetails: any) {
        return pageWidgetDetails?.flatMap((page: any) =>
            page.widget_details.map((widget: any) => ({
              widgetId: widget.widgetId,
              widgetLabel: widget.widgetLabel,
              widgetType: widget.widgetType,
              widgetConfig:widget.widgetConfig
            }))
          ) || [];
        }

   

    

      addField(): FormGroup {
        return this._formBuilder.group({
          widgetId: '',
        });
      }
      patchField(data: any): FormGroup {
        return this._formBuilder.group({
          widgetId: data,
        });
      }

      addLhsFieldsInCard() {
        this.isLhsclicked = true;
        this.lhsItems.push(this.addField());
      }
    
      removeLhsFieldsInCard(index: number) {
        this.lhsItems.removeAt(index)
      }
    
      addRhsFieldsInCard() {
        this.isRhsclicked = true;
        this.rhsItems.push(this.addField())
      }
    
      removeRhsFieldsInCard(index: number) {
        this.rhsItems.removeAt(index);
      }
      
  //#endregion
  
  //#region Submit action

    async addSubmitAction(){
      let actions = this.widget.widgetConfig.actions;
      await this.widgetPropertyFormService.addOrDeletePreviewPage(this.widget,this.previewGroup.get('preview')?.value,this.pages,this.queryParams['pageId'],this.queryParams['id']);
      let apiDetails ={
        apiUrl: "dummyurl",
        method: "Post",
        apiId:'submit'
      }
      if(!this.previewGroup.get('preview')?.value){
        this.previewGroup.get('preview')?.patchValue(false)
      }
      let dataSource = await this.actionDataSourceAdd(apiDetails);
      this.checkActionExixtance(actions,this.widgetClickActions.submit, [],dataSource);
    }

    /**
     * added or update's the datasource of current widget for submit action
     * @param apiDetails : selected api json
     * @returns updated Datasource
     */
    actionDataSourceAdd(apiDetails:any): any {
      let dataSource = {};
      let preview = this.previewGroup.get('preview')?.value ? this.previewGroup.get('preview')?.value : false;
      dataSource = {
        "datasourceType": "api",
        "datasource": apiDetails?.['apiUrl'],
        "request-parameter": [],
        "response-parameter": apiDetails?.responseParameter ? { label: apiDetails?.responseParameter } : null,
        "method": apiDetails?.['method'],
        "preview": preview,
        "Authorization": {
          "auth-api-url": apiDetails?.['authApiUrl'] ? apiDetails?.['authApiUrl'] : "",
          "auth": apiDetails?.['auth'] ? apiDetails?.['auth'] : "",
          "api-key": apiDetails?.['apiKey'] ? apiDetails?.['apiKey'] : "",
        }
      }
      return dataSource;
    }

  //#endregion
  
  //#region Workflow action

    addWorkFlowAction(actions: WIDGETACTION[]) {    
      //checking valid form group
      if (this.workFlowGroup.valid) {
        const workFlowId = this.selectedEntityWorkflows.find((workflow:any) => workflow.workflow_name === this.workFlowGroup.get('workFlowName')?.value)?.workflow_id;
        // creating obj for navigation action
        const workflowAction: any = {
          action: workFlowId,
          entity: this.workFlowGroup.get('entity')?.value
        };
        workflowAction[this.widget.widgetId] = ["default"];
        workflowAction['widgets'] = [this.widget.widgetId];
        this.checkActionExixtance(actions,this.widgetClickActions.workFlow, [workflowAction]);
      }
    }
  //#endregion
  
  //#region conditional navigation action
    addCondiotionAction(){
      let actions = this.widget.widgetConfig.actions;
      //creating conditional action conditions
      const newCondition = this.createConditionObject(
        this.conditionalActionGroup.get("pageName")?.value,
        this.conditionalActionGroup.get("parameters")?.value,
        this.NavigationConditionals
      );
      this.conditionalActions.push(newCondition);
      this.checkActionExixtance(actions,this.widgetClickActions.conditionalNavigation, [...this.conditionalActions]);
      this.resetConditionalState(
        this.NavigationConditionals,
        this.conditionalActionGroup,
        "pageName"
      );
    }

    /**
     * sets the form and data for a condition in conditional navigation action
     * @param actionObj : current condition object
     */
    setConditionalValue(actionObj:ACTIONCONDITIONALCLAUSE ) {
      this.currentConditions = [];
      this.conditionalActionUpdatedGroup.patchValue({
        pageName: actionObj.action,
        parameters: actionObj.parameters,
      })
      this.filterConditionalNavigationWidgets();
      this.currentPageConditionalWidgetsUpdate = structuredClone(this.currentPageConditionalWidgets);
      this.conditionalKeyValue = Object.entries(actionObj)
      .filter(([key]) => !['action', 'parameters', 'widgets'].includes(key))
      .map(([key, values]) => ({ key, values }));
      this.conditionalKeyValue.forEach((condition:any) => {
        this.patchConditionalField(condition.key,condition.values,this.currentConditions,this.currentPageConditionalWidgetsUpdate);
      })
    }

     /**
     * Shows confirmation dialog before deleting conditional workflow action
     * @param index : current condition index
     */
     async confirmDeleteConditionalNavigationAction(index: number,actions:WIDGETACTION[]) {
      const dialogRef = this.dialog.open(this.confirmationDialog, {
        width: '400px',
        data:{
          message: 'Are you sure you want to delete this conditional navigation action?'
        }
      });

      const result = await dialogRef.afterClosed().toPromise();
      
      if (result) {
        this.deleteConditionalAction(index,actions);
      }
    }


    /**
     * delete's selected condition from conditional navigation action
     * @param index : current condition index
     * @param actions : current widget actions
     */
    deleteConditionalAction(index: number, actions: WIDGETACTION[]) {
      const actionIndex = actions.findIndex((action:any) => action.action_type === this.widgetClickActions.conditionalNavigation);
      if (actionIndex !== -1) {
        const clauses = actions[actionIndex].conditional_clause;
        if (index >= 0 && index < clauses.length) {
          this.handleSingleClauseRemoval(actions, this.widgetClickActions.conditionalNavigation, index, this.selectedActions, clauses);
          this.conditionalActions.splice(index, 1);
          this.updateActionsList(actions, this.widgetClickActions.conditionalNavigation, clauses);
        }
      }
    }

    /**
     * update's a specific condition in conditional navigation action
     * @param actionType : action Type
     * @param index : index of current condition
     * @param currentActionConditions : conditions of the current action
     */
    updateConditionalActions(actionType: string, index: number,currentActionConditions:ACTIONCONDITIONALCLAUSE[]) {
      const updatedCondition = this.createConditionObject(
        this.conditionalActionUpdatedGroup.get('pageName')?.value,
        this.conditionalActionUpdatedGroup.get('parameters')?.value,
        currentActionConditions
      );
        this.conditionalActions[index] = updatedCondition;
       this.updateActionsList(this.widget.widgetConfig.actions, actionType, [...this.conditionalActions])
    }
  //#endregion
  
  //#region Conditional Workflow action

    addConditionalWorkflowAction(actions:WIDGETACTION[]){
      const newCondition = this.createConditionObject(
        this.workFlowConditionGroup.get('workFlowId')?.value,
        this.workFlowConditionGroup.get('parameters')?.value,
        this.NavigationConditionals
      );
    
      newCondition.entity = this.workFlowConditionGroup.get('entity')?.value;
      newCondition.workFlowList = this.selectedEntityWorkflows;
      this.workflowConditionalActions.push(newCondition);
    
      const clonedWorkflowActions = structuredClone(this.workflowConditionalActions).map((action: any) => {
        delete action['workFlowList'];
        return action;
      });    
      this.checkActionExixtance(actions, this.widgetClickActions.conditionalWorkflow, clonedWorkflowActions);
      this.resetConditionalState(this.NavigationConditionals, this.workFlowConditionGroup, 'entity', 'workFlowName');
    }

    /**
    * sets the form and data for a condition in conditional workflow action
    * @param actionObj : current condition object
    */
    async setWorkFlowConditionalValue(workflow: ACTIONCONDITIONALCLAUSE) {    
      this.workFlowConditionUpdatedGroup.reset();
      this.workflowConditions = [];
      this.currentPageConditionalWidgetsUpdate = [];
      this.selectedEntityWorkflows = workflow.workFlowList ?? await this.sharedService.fetchWorkFlows(workflow.entity ?? '', 'entity');
      this.workFlowConditionUpdatedGroup.patchValue({
        entity: workflow.entity,
        workFlowId: workflow.action,
        parameters: workflow.parameters,
      },{onlySelf:true,emitEvent:false})
      this.currentPageConditionalWidgetsUpdate = structuredClone(this.currentPageConditionalWidgets);
      this.conditionalKeyValue = Object.entries(workflow).filter(([key]) => !["action","parameters","widgets","entity","workFlowList"].includes(key)).map(([key, values]) => ({ key, values }));
      this.conditionalKeyValue.forEach((condition:any) => {
        this.patchConditionalField(condition.key,condition.values,this.workflowConditions,this.currentPageConditionalWidgetsUpdate);
      })
    }

    /**
    * update's a specific condition in conditional workflow action
    * @param actionType : action Type
    * @param index : index of current condition
    * @param currentActionConditions : conditions of the current action
    */
    updateConditionalWorkflowAction(actionType: string, index: number,currentActionConditions:ACTIONCONDITIONALCLAUSE[]){
      const updatedWorkflowCondition = this.createConditionObject(
        this.workFlowConditionUpdatedGroup.get('workFlowId')?.value,
        this.workFlowConditionUpdatedGroup.get('parameters')?.value,
        currentActionConditions
      );
      updatedWorkflowCondition.entity = this.workFlowConditionUpdatedGroup.get('entity')?.value;
      updatedWorkflowCondition.workFlowList = this.workflowConditionalActions[index]['workFlowList'];
      this.workflowConditionalActions[index] = updatedWorkflowCondition;
      const updatedWorkflowActions = structuredClone(this.workflowConditionalActions).map((action: ACTIONCONDITIONALCLAUSE) => {
        delete action['workFlowList'];
        return action;
      });
      this.updateActionsList(this.widget.widgetConfig.actions, actionType, updatedWorkflowActions);
      this.conditionalWorkFlowEditGroup.get('search')?.reset();
      this.resetSearch();
      
    }

    resetSearch(){
      this.resetSearchVar = false;
      setTimeout(()=>{
        this.resetSearchVar = true;
      },15)
    }

    /**
     * Shows confirmation dialog before deleting conditional workflow action
     * @param index : current condition index
     */
    async confirmDeleteConditionalWorkFlowAction(index: number) {
      const dialogRef = this.dialog.open(this.confirmationDialog, {
        width: '400px',
        data:{
          message: 'Are you sure you want to delete this conditional workflow action?'
        }
      });

      const result = await dialogRef.afterClosed().toPromise();
      
      if (result) {
        this.deleteConditionalWorkFlowAction(index);
      }
    }

    /**
    * delete's selected condition from conditional navigation action
    * @param index : current condition index
    * @param action : condition to be removed
    */
    async deleteConditionalWorkFlowAction(index: number) {
      const actions = this.widget.widgetConfig.actions;
      const actionIndex = actions.findIndex((action: WIDGETACTION) => action.action_type === this.widgetClickActions.conditionalWorkflow);
      if (actionIndex !== -1) {
        const clauses = actions[actionIndex].conditional_clause;
        if (index >= 0 && index < clauses.length) {
          this.handleSingleClauseRemoval(actions, this.widgetClickActions.conditionalWorkflow, index, this.selectedActions, clauses);
          this.workflowConditionalActions.splice(index, 1);
          this.updateActionsList(actions, this.widgetClickActions.conditionalWorkflow, clauses);
          this.conditionalWorkFlowEditGroup.get('search')?.reset();
          this.resetSearch();
        }
      }
    }

    /**
     * make's an api call and sets the workflowslist for every condition
     * @param workflowConditionalActions : conditions of conditional workflow action
     */
    async setConditionWorkflowsList(workflowConditionalActions: ACTIONCONDITIONALCLAUSE[]) {
      let entitysAndRelatedWorkflows: any = {};
      // Get a list of unique workflow actions by `entity` and fetch required values
      const uniqueEntities =  new Map(workflowConditionalActions.map(action => [action.entity, action])).values()
      for (const workflowAction of uniqueEntities) {
        const entityId = workflowAction.entity ?? '';
        if (!entitysAndRelatedWorkflows[entityId]) {
          entitysAndRelatedWorkflows[entityId] = await this.sharedService.fetchWorkFlows(entityId, 'entity')
        }
      }
      // Assign fetched workflows to each action in the original list
      workflowConditionalActions.forEach(action => {
        const entityId = action.entity ?? '';
        action.workFlowList = entitysAndRelatedWorkflows[entityId] || [];
      });
    }
  //#endregion

  //#region Request Action
    getUserApisList(){
      this.userconfiguredApis = this.apiConfigService.getUserApis();
    }

    get apiVariables(): FormArray {
      return this.requestGroup.get('variables') as FormArray;
    }

    requestGroupValueChanges(){
      this.requestGroup.get('api')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((apiId:string) => {
      let selectedApi : USERDEFINEDAPI =  this.userconfiguredApis.apis.find((api:any) => api.apiId === apiId);
      if(selectedApi.variables && selectedApi.variables.length > 0){
        selectedApi.variables.forEach((variable:USERDEFINEDAPIVARIABLE) => {
          this.addVariable(variable);
        })
      }
      })
    }

    /**
     * Add's a variableGroup to the apiVariables for request action. 
     * @param variableObj 
     */
    addVariable(variableObj:USERDEFINEDAPIVARIABLE): void {
      const variableGroup = this._formBuilder.group({
        name: ['', Validators.required],
        value: ['', Validators.required]
      });
      variableGroup.get('name')?.patchValue(variableObj.key)
      this.apiVariables.push(variableGroup);
    }

    /**
    * Add's a variableGroup to the apiVariables for request action. 
    * @param variableObj 
    */ 
      patchVariable(variableObj:any){
      const variableGroup = this._formBuilder.group({
        name: ['', Validators.required],
        value: ['', Validators.required]
      });
      variableGroup.get('name')?.patchValue(variableObj.variableName)
      variableGroup.get('value')?.patchValue(variableObj.widget)
      this.apiVariables.push(variableGroup);
    }

    /**
     * add or edit's the request action
     * @param actions current widget actions
     */
    addorEditRequestAction(actions:WIDGETACTION[]){
      if (this.requestGroup.valid) {
        let dataSource = this.requestActionDataSourceAdd(this.requestGroup.value);
        this.checkActionExixtance(actions,this.widgetClickActions.request, [],dataSource);
      }
    }

    /**
     * add or update's the datasource of current widget with selected api for request action
     * @param requestActionDetails request action object
     * @returns dataSource
     */
    requestActionDataSourceAdd(requestActionDetails:any): any {
      let dataSource = {};
      let keyValueVariableObj = {};
      if(requestActionDetails.variables && requestActionDetails.variables.length > 0){
        keyValueVariableObj = Object.fromEntries(
          requestActionDetails.variables.map((item:any) => [item.name, item.value])
      );
      }
      dataSource = {
        "datasourceType": "api",
        "datasource": requestActionDetails.api,
        "variableMappedWidgets" : keyValueVariableObj ,
        "displayKeys": this.requestActionDisplayKeysObjectFormatter("save",requestActionDetails.displayKeys)
      }
      return dataSource;
    }

    requestActionDisplayKeysObjectFormatter(caseType:string,keys:any){
      let displaykeys:any = [];
      if(caseType === 'save'){
        keys.forEach((value:string) => {
          displaykeys.push({"key":value});
        })
      }else if(caseType === 'patch'){
        keys.forEach((keyObj:any) => {
          displaykeys.push(keyObj.key);
        })
      }
      return displaykeys;
    }

     // Recursive function to get keys and paths
    getKeyPaths(response: any, currentPath: string = ''): KeyPath[] {
        
      let result: KeyPath[] = [];

      if (typeof response === 'object' && response !== null) {
        for (const key in response) {
          if (response.hasOwnProperty(key)) {
            const newPath = currentPath ? `${currentPath}.${key}` : key;
            
            // Add to result if it's a simple value
            if(typeof response[key] !== 'object'){
              result.push({ label: key, path: newPath });
            }
            
            // If value is an array, only take keys from the first item
            if (Array.isArray(response[key]) && response[key].length > 0) {
              result = result.concat(this.getKeyPaths(response[key][0], newPath));
            } 
            // If value is an object, recurse
            else if (typeof response[key] === 'object' && response[key] !== null) {
              result = result.concat(this.getKeyPaths(response[key], newPath));
            }
          }
        }
      }
      return result;
    }


    async  makeApiCall(apiId:string){
      if(!apiId){
        return;
      }
      let result =  await this.apiConfigService.makeApiRequestWithDefaultValues(apiId);
      if(result.status){
          this.apiKeyPaths = this.getKeyPaths(result.response)
      }else{
        console.warn('failed to fetch api details');
      }

    }

  //#endregion

  //#region Template #actionConditions
    /**
     * filters the widgets in current page for conditional widgets i.e. dropdown,radio,checkbox
     */
    filterConditionalWidgets(){
      this.currentPageConditionalWidgets = this.currentPageWidgets.filter((widget:any) => [this.widgetTypes.dropdown,this.widgetTypes.radio,this.widgetTypes.singleselectcheckbox].includes(widget.widgetType));
    }

    filterConditionalNavigationWidgets(){
      this.currentPageConditionalWidgets = this.currentEntitybasedConditionalWidgets.filter((widget:any) => [this.widgetTypes.dropdown,this.widgetTypes.radio,this.widgetTypes.singleselectcheckbox].includes(widget.widgetType));
    }

    async setEntityWidgetsGroup(){
      let page = this.pages.find((page:any) => page.pageId === this.queryParams['pageId']);
      if(page && page.entityId){
        const payload = {
          application_id: this.queryParams['id'],
          entity_id: page.entityId,
          project_id: null,
          parent_entity_id: null
        }
        const listOfPageWidgetsOfEntity : any = await firstValueFrom(this.widgetPropertyFormService.getEntitiesOrAttributes(payload));
        this.currentEntitybasedConditionalWidgets = this.widgetPropertyFormService.retriveWidgetsListFromEntiywithConfig(listOfPageWidgetsOfEntity?.page_widget_details) 
      }else{
        this.currentEntitybasedConditionalWidgets = this.currentPageWidgets;
      }
    }

    /**
     * removes a specfic condtion in conditionalfield.
     * @param index :index of the specfic condition
     * @param item : conditional field
     * @param conditionals : existing conditional fields and their values object
     * @param conditionalsWidgets : current page conditional widgets
     */
    delectChipGridItem(index: number, item: any,conditionals:any,conditionalsWidgets:any) {
      conditionals.splice(index, 1);
      conditionalsWidgets.push(item.key);
    }

    addManualValue(value:string,condition:any,inputElement:any){
      if(!condition['manual']){
        condition['manual']= []
      }
      const option = condition.manual.find((option:any) => option === value);
      if(!option){
        condition.manual.push(value);
        inputElement.value = '';
      }

    }

    removeManualValue(value:string,options:string[]){
      const optionIndex = options.findIndex((option:any) => option === value);
      if(optionIndex >= 0 ){
        options.splice(optionIndex,1);
      }
    }

    checkOptionExistsInConditionOptions(value:string,options:any){
      const option = options.find((option:any) => option.label === value);
      return option;
    }

    /**
     * Add's a conditional field
     * @param index : index of the current condition of action to add a conditional field
     * @param widget : selected conditional widget from conditional widgets
     * @param conditionals : conditional fields
     * @param conditionalWidgets : current page conditional widgets
     */
    addFieldCondition(index: number, widget: any,conditionals:any,conditionalWidgets:any) {
      let options = [];
      if (widget.widgetType == this.widgetTypes.dropdown && widget?.widgetDataSource?.datasourceType == 'manual') {  
        options = widget.widgetDataSource.datasource;
      }else if (widget.widgetType == this.widgetTypes.radio) {
        options = widget.widgetDataSource.datasource;
      }else if (widget.widgetType == this.widgetTypes.singleselectcheckbox) {
        options = [{key:'',label:'checked'},{key:'',label:'unchecked'}]
      }
      conditionals.push({ key: widget, values: [],options:options });
      conditionalWidgets.splice(index, 1);
    }

    /**
     * patches the values of the conditional field
     * @param widgetId : conditional widget's widgetId
     * @param values : values to be patched
     * @param conditions : conditional fields
     * @param conditionalWidgets : current page conditional widgets
     */
    patchConditionalField(widgetId:string,values:string[],conditions:any,conditionalWidgets:any){
      let options:any = [];
      let widgetIndex  = conditionalWidgets.findIndex((widget:any) => widget.widgetId === widgetId);
      let widget = conditionalWidgets[widgetIndex]
      if (widget.widgetType == this.widgetTypes.dropdown && widget?.widgetDataSource?.datasourceType == 'manual') {  
        options = widget.widgetDataSource.datasource ?? [];
      }else if (widget.widgetType == this.widgetTypes.radio) {
        options = widget.widgetDataSource.datasource ?? [];
      }else if (widget.widgetType == this.widgetTypes.singleselectcheckbox) {
        options = [{key:'',label:'checked'},{key:'',label:'unchecked'}]
      }
      let manualValues:string[] = [];
      let selectedValues:string[] = [];
      values.forEach((value:any) => {
        if(this.checkOptionExistsInConditionOptions(value,options)){
          selectedValues.push(value);
        }else{
          manualValues.push(value);
        }})
      conditions.push({ key: widget, values: selectedValues,options:options,manual:manualValues });
      conditionalWidgets.splice(widgetIndex, 1);
    }
  //#endregion

  //#region Helper Methods
    // for conditional navigation and conditional workflow
      /**
       * resets the state of conditional action (conditional workflow,conditional action)
       * @param conditionalArray : conditions of specfic action
       * @param formGroup : specific action form group
       * @param fields : fields to reset
       */
      private resetConditionalState(conditionalArray: any[], formGroup: FormGroup, ...fields: string[]) {
        conditionalArray.length = 0; // Clears the array
        formGroup.reset();
        this.filterConditionalWidgets();
        this.filterConditionalNavigationWidgets();
      }
      
      /**
       * creates the action object  of specfied action
       * @param action : action key value of the specified action
       * @param parameters : parameters of the specific action or action condition
       * @param conditions : current page conditional actions
       * @returns 
       */
      private createConditionObject(action: string, parameters: any, conditions: any[]): any {
        const conditionObj: any = { action, parameters, widgets: [] };
        conditions.forEach((condition: any) => {
          condition.values = condition?.manual ? [...condition.values, ...condition.manual] : condition.values;
          conditionObj[condition.key.widgetId] = condition.values;
          conditionObj.widgets.push(condition.key.widgetId);
        });
        return conditionObj;
      }

      /**
       * update's the conditions of a specified action
       * @param actions : current widget actions
       * @param actionType : specified action type
       * @param clauseArray : conditions of the specified action
       */
      private updateActionsList(actions: WIDGETACTION[], actionType: string, clauseArray: ACTIONCONDITIONALCLAUSE[]) {
        const actionIndex = actions.findIndex((action: any) => action.action_type === actionType);
        if (actionIndex !== -1) {
          actions[actionIndex].conditional_clause = clauseArray;
          this.updateActions([...actions], actionType);
        }
      }
      
      /**
       * removes a single condition from specified action;k
       * @param actions : current widget actions
       * @param actionType : specfied action type
       * @param index : index of the condition tpo be removed
       * @param selectedActionsArray current user selected actions
       * @param clauseArray : conditions
       */
      private handleSingleClauseRemoval(actions: WIDGETACTION[], actionType: string, index: number, selectedActionsArray: string[], clauseArray: ACTIONCONDITIONALCLAUSE[]) {
        if (clauseArray.length === 1 && index === 0) {
          this.widget.widgetConfig.actions = actions.filter((action: any) => action.action_type !== actionType);
          selectedActionsArray.splice(index, 1);
          this.updateAvailableActionsList(actionType);
        } else {
          clauseArray.splice(index, 1);
        }
      }
    // -----------------

    // for Navigation and line item Action
    /**
     * add navigation or lineitem action beased on action type
     * @param actions : widget actions
     * @param formGroup : specific action form group
     * @param actionType : specified action type
     */
      addNavigationOrLineItemAction(actions: WIDGETACTION[], formGroup: FormGroup, actionType: string) {
        if (formGroup.valid) {
          const pageId = this.pages.find((page: any) => page.pageName === formGroup.get('pageName')?.value)?.pageId;
          const actionObj: any = {
            action: pageId,
            [this.widget.widgetId]: ["default"],
            widgets: [this.widget.widgetId]
          };
          if(actionType === this.widgetClickActions.lineItem){
            const lineItemGroup = this.lineItemGroup.getRawValue();
            this.widget.widgetConfig.additionalConfig["lineItemConfig"] = {
              entityId:lineItemGroup["entityId"] ?? '',
              lhsItems:this.lhsItems.getRawValue(),
              rhsItems:this.rhsItems.getRawValue(),
              bulk:lineItemGroup['bulk'] ?? false,
              table:lineItemGroup['table'] ?? false,
              delete:lineItemGroup['delete'] ?? false,
              referenceWidget:lineItemGroup['referenceWidget'] ?? '',
              displayLineItems:lineItemGroup['displayLineItems'] ?? '',
              defaultValues:this.defaultValuesFormatter(lineItemGroup['defaultValues']) ?? {},
            }
            let widgetValidations = this.widget.widgetConfig?.validations || [];
            let formValidation = widgetValidations.find((validation: any) => validation.validation_type === this.widgetValidationTypes.formValidation);
            if (!formValidation) {
              formValidation = {
                error_message: "",
                validation_key: "form_validation",
                validation_type: this.widgetValidationTypes.formValidation ?? '',
                validation_value: {},
              };
              widgetValidations.push(formValidation);
            }
            if(formValidation.validation_subtype === 'entity'){
              formValidation['validation_entity'] = lineItemGroup.validationEntity.foreignEntityId ?? '';
              formValidation['basedOn'] = lineItemGroup.validationEntity.basedOn ?? '';
              formValidation['operator'] = lineItemGroup.validationEntity.operator ?? '';
              formValidation['filters'] = this.widgetPropertyFormService.formatInToBasedWidgetIds(lineItemGroup.validationEntity.filters) ?? [];
              formValidation.validation_value = {
                "label": lineItemGroup.validationEntity.label ?? '',
                "key": lineItemGroup.validationEntity.key ?? ''
              };
            }else{
              formValidation.validation_value = this.validationsFormatter(lineItemGroup['validations'],lineItemGroup['validationType']) ?? [];
              
            }
            
            formValidation.validation_subtype = lineItemGroup['validationType'];
            formValidation.error_message = lineItemGroup['validationErrorMessage'] ?? "";
            this.widget.widgetConfig.validations = widgetValidations;
          }
          this.checkActionExixtance(actions, actionType, [actionObj]);
        }
      }

      async setEntityWidgetsMapping(entities:any){
        let entitysAndRelatedWidgets: any = this.entitiesWidgetsMaping;
         if(entities){
           for (const entity of entities) {
             const entityId = entity;
             if (!this.entitiesWidgetsMaping[entityId]) {
               let response : any = await firstValueFrom(this.widgetPropertyFormService.fetchEntity(entityId,this.applicationId))
               entitysAndRelatedWidgets[entityId] = this.widgetPropertyFormService.retriveWidgetsListFromEntiywithConfig(response.data?.page_widget_details);
             }
           }
         }
   
         this.entitiesWidgetsMaping = entitysAndRelatedWidgets;
     }
  //#endregion
 
  ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }
  
}

interface KeyPath {
  label: string;  // Label to display in dropdown
  path: string;   // Path to use for accessing the key
}